import { Pipe, PipeTransform } from '@angular/core';
import { PackingOrder } from '../models/entities/packing-order';




@Pipe({
  name: 'packing-order-pipe'
})

export class PackingOrderPipe implements PipeTransform {
  
  constructor(){}

  transform(packingOrder: PackingOrder, field: string): any {
    let result = packingOrder[field];

   //  if (field == 'progressLevel') {
   //   if  (result == AssetAssignmentPL.pl_newly_created)      return "<div class='label-gray'>"    + 'Demande'                + "</div>";
   // }

    return result;
  }
}
